import MuiRadio, { RadioProps as MuiRadioProps } from '@mui/material/Radio';

export type RadioProps = MuiRadioProps;

export const Radio: React.FC<RadioProps> = (props) => <MuiRadio {...props} />;
